export interface WhoWeAreContent {
  heroTitle: string;
  section1: {
    title: string;
    text: string;
  };
  section2: {
    title: string;
    text: string;
  };
  section3: {
    title: string;
    text: string;
  };
  section4: {
    title: string;
    locationTitle: string;
    locationText: string;
    equipmentTitle: string;
    equipmentText: string;
  };
  section5: {
    title: string;
    intro: string;
    cards: string[];
    outro: string;
  };
}

export const DEFAULT_WHO_WE_ARE_CONTENT: WhoWeAreContent = {
  heroTitle: "ReZone : Plus qu'une LAN !",
  section1: {
    title: "Qu'est-ce qu'une LAN ?",
    text: "Une LAN (Local Area Network), c'est bien plus que des ordinateurs connectés en réseau. C'est un rassemblement de passionnés qui se retrouvent physiquement dans un même lieu pour partager leur amour du jeu vidéo, échanger, s'affronter et surtout s'amuser ensemble, loin de l'isolement du jeu en ligne classique."
  },
  section2: {
    title: "L'ADN ReZone : Le jeu, le vrai, ensemble",
    text: "<p>Dans un monde où le jeu vidéo se vit de plus en plus chacun chez soi avec un casque sur les oreilles, ReZone fait de la résistance conviviale. Notre credo ? <strong>Nous étions là en 2001, nous ne nous éteindrons pas !</strong></p><p>Le câble réseau qui traîne par terre, l'odeur du café (et parfois de la pizza) et surtout, le plaisir de voir l'adversaire en face quand on gagne (ou qu'on perd) !</p><p>Nous ne sommes pas une simple salle de jeux, nous sommes une association loi 1901 dédiée à la promotion du jeu en réseau et de la culture vidéoludique. Que tu sois un hardcore gamer ou un joueur du dimanche, l'esprit reste le même : le fair-play et le fun avant la compétition pure.</p>"
  },
  section3: {
    title: "Une aventure historique",
    text: "<p>L'aventure a commencé il y a déjà longtemps, en <strong>2001</strong>. De nos premières LANs dans des garages à de grands évènements où nous étions plus de 80 !!! nous avons vu passer des générations de jeux, et de gamers.</p><p>Mais ReZone, c'est aussi un engagement local. Nous sommes fiers d'organiser régulièrement des événements caritatifs, notamment pour le Téléthon, prouvant que les gamers ont du cœur.</p>"
  },
  section4: {
    title: "Infos Pratiques",
    locationTitle: "📍 Où nous trouver ?",
    locationText: "L'association navigue principalement entre <strong>Lardy</strong> et <strong>Bouray-sur-Juine</strong>.",
    equipmentTitle: "💻 Le Matos",
    equipmentText: "On gère l'infrastructure réseau, tu apportes ta machine (<strong>BYOC</strong> - Bring Your Own Computer) et ta bonne humeur."
  },
  section5: {
    title: "Pourquoi nous rejoindre ?",
    intro: "Parce que rien ne remplace l'adrénaline d'une salle remplie de joueurs passionnés.",
    cards: [
      "Tu veux sortir de ta chambre ?",
      "Tu veux poncer tes classiques ?",
      "Tu veux rencontrer une communauté locale active ?"
    ],
    outro: "ReZone est faite pour toi ! On t'aime déjà ! ❤️"
  }
};
